import request from '@/utils/request'

// 查询列表 通过编号
export function getCartItemlistReq(query) {
  return request({
    url: '/api/cartItem/getCartItemlist',
    method: 'GET',
    params: query , //params修改为data
  })
}

//delCartItem
export function delCartItemReq(query) {
  return request({
    url: '/api/cartItem/delCartItem',
    method: 'GET',
    params: query , //params修改为data
  })
}

export function updageCartItemReq(query) {
  return request({
    url: '/api/cartItem/updateCartItem',
    method: 'GET',
    params: query , //params修改为data
  })
}

export function getCheckPayCnt(query) {
  return request({
    url: '/api/order/getCheckPayCnt',
    method: 'GET',
    params: query , //params修改为data
  })
}
